var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-week",
    "data-name": "Icon awesome-calendar-week",
    d: "M0,27.41a2.922,2.922,0,0,0,3,2.836H25a2.922,2.922,0,0,0,3-2.836V11.342H0ZM4,16.068a.977.977,0,0,1,1-.945H23a.977.977,0,0,1,1,.945v3.781a.977.977,0,0,1-1,.945H5a.977.977,0,0,1-1-.945ZM25,3.781H22V.945A.977.977,0,0,0,21,0H19a.977.977,0,0,0-1,.945V3.781H10V.945A.977.977,0,0,0,9,0H7A.977.977,0,0,0,6,.945V3.781H3A2.922,2.922,0,0,0,0,6.616V9.452H28V6.616A2.922,2.922,0,0,0,25,3.781Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyCalendar);
export default __webpack_public_path__ + "static/media/monthly-calendar.53c40664ca5c2011a05112c8d163a36a.svg";
export { ForwardRef as ReactComponent };